import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldProps } from '../../../../../../../@types/types'
import { ObjectDetailsScreenValidationResult } from '../../../../../../../@types/validation-types'
import Stepper from '../../../../../../common/inputs/stepper/Stepper'
import LabelWithTooltip from '../../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../common/PopoverContent'

export interface TotalFloorsProps extends FieldProps<ObjectDetailsScreenValidationResult> {
  wrapperClassName?: string
  labelTranslationKey?: string
  showMandatory?: boolean
}

export const TotalFloors: React.FC<TotalFloorsProps> = ({
  insertionData,
  validationMessages,
  screenName,
  onChange,
  wrapperClassName = '',
  labelTranslationKey = 'wizard.screen.objectDetails.totalFloors',
  showMandatory = false,
}) => {
  const { t } = useTranslation()

  const labelWithTooltip = (
    <LabelWithTooltip
      inputId='total-floors'
      labelText={t(labelTranslationKey)}
      tooltipContent={<PopoverContent translationKey='wizard.screen.objectDetails.totalFloors.tooltip' />}
      showMandatory={showMandatory}
      arrowPosition='left'
      containerClassName='margin-bottom-xs'
    />
  )

  return (
    <div className={wrapperClassName}>
      {labelWithTooltip}
      <Stepper
        id='total-floors'
        propertyName='totalFloorsNumber'
        placeholder={t('wizard.screen.objectDetails.placeholder.amount')}
        input={insertionData.totalFloorsNumber}
        type='tel'
        max={999}
        step={1}
        errors={validationMessages?.totalFloorsNumber ?? []}
        doOnFieldChange={(property, value) => onChange({ screen: screenName, property }, value)}
      />
    </div>
  )
}
